import React, { MouseEvent, ReactNode } from "react";

import { ToggleButtonGroup, ToggleButtonGroupProps } from "@mui/material";

type IgToggleButtonGroupProps = Omit<
  ToggleButtonGroupProps,
  "onChange" | "value" | "exclusive"
> & {
  control: {
    onChange: (event: MouseEvent<HTMLElement>, val: any) => void;
    exclusive?: boolean;
  };
  value: any;
  buttons: ReactNode[];
};

export const IgToggleButtonGroup = ({
  buttons,
  control,
  value,
  ...props
}: IgToggleButtonGroupProps) => {
  const { sx, ...rest } = props;
  return (
    <ToggleButtonGroup {...control} {...rest} value={value} sx={sx}>
      {buttons}
    </ToggleButtonGroup>
  );
};
